import { createContext } from "react";
import { Profile } from "./index";

const ProfileContext = createContext<{ data?: Profile }>({});

export default ProfileContext;
